import { useEffect } from 'react';
import { AppState } from 'react-native';

import { AppStateChangeHandler } from './types';

export const useAppStateChangeHandler = (
  handler: AppStateChangeHandler
): void => {
  useEffect(() => {
    const subscription = AppState.addEventListener('change', handler);
    return function cleanupChangeHandler() {
      subscription.remove();
    };
  }, [handler]);
};
